import React from "react";
import { Helmet } from "react-helmet";

export default function PrivacyPolicy() {
  return (
    <div className="page">
      <Helmet><title>Privacy Policy | RO Service Patna</title></Helmet>
      <h1>Privacy Policy</h1>
      <p>We respect your privacy. All personal data submitted on this website is used only to provide RO services.</p>
      <p>We do not sell or share your personal information with any third parties.</p>

            <h3>1. Introduction</h3>

            <p>
              At RO Service Center, we prioritize your privacy and are committed
              to protecting your personal information. This Privacy Policy
              explains how we collect, use, disclose, and protect your
              information when you use our services. By engaging with our
              services, you agree to the practices described in this policy.
            </p>

            <h3>2. Information We Collect</h3>

            <p>We may collect and process the following types of personal information:</p>

            <ul>
              <li>
                <strong>Personal Identification Information:</strong> This
                includes your name, phone number, email address, and location.
              </li>

              <li>
                <strong>Service-Related Information:</strong> Details about the
                services you request, including service history, feedback, and
                specific requirements.
              </li>

              <li>
                <strong>Technical Data:</strong> Information related to your
                device, such as IP address, browser type, and usage data.
              </li>
            </ul>

            <h3>3. How We Use Your Information</h3>

            <p>The information we collect is used for the following purposes:</p>

            <ul>
              <li>
                <strong>To Provide Services:</strong> To schedule and provide
                water purifier repair and maintenance services.
              </li>

              <li>
                <strong>To Communicate:</strong> To contact you with updates,
                promotions, and relevant information.
              </li>

              <li>
                <strong>To Improve Our Services:</strong> To analyze service
                feedback and website usage.
              </li>

              <li>
                <strong>Legal Compliance:</strong> To comply with legal
                obligations and protect our legal rights.
              </li>
            </ul>

            <h3>4. Sharing Your Information</h3>

            <p>
              We do not sell or rent your personal information to third parties.
            </p>

            <ul>
              <li>
                <strong>Service Providers:</strong> Third-party companies that
                assist us in delivering services.
              </li>

              <li>
                <strong>Legal Authorities:</strong> If required by law.
              </li>
            </ul>

            <h3>5. Data Security</h3>

            <p>
              We implement appropriate security measures to protect your
              personal information from unauthorized access, use, or disclosure.
            </p>

            <h3>6. Your Rights</h3>

            <ul>
              <li>
                <strong>Access and Update:</strong> Update your personal
                information.
              </li>

              <li>
                <strong>Delete:</strong> Request deletion of your information.
              </li>

              <li>
                <strong>Restrict Processing:</strong> Request restrictions on
                processing.
              </li>

              <li>
                <strong>Withdraw Consent:</strong> Withdraw consent at any time.
              </li>
            </ul>

            <h3>7. Changes to This Privacy Policy</h3>

            <p>
              We may update this Privacy Policy periodically. Any changes will
              be posted on this page.
            </p>

    </div>
  );
}